export const getActiveUser = (store) => store.user;

export const isUserLogedIn = (store) => !!store.user.token;
